import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { errorMessage, successMessage } from "../../../utils/helper";
import { getPOSSyncSettings, updatePOSSyncSettings } from "../api/PosSyncApi";

const posSyncSettingsKeys = {
  all: ["posSyncSettings"],
  settings: () => [...posSyncSettingsKeys.all, "settings"],
};

export const usePOSSyncSettingsQueries = () => {
  const queryClient = useQueryClient();

  // Fetch settings query
  const settingsQuery = useQuery({
    queryKey: posSyncSettingsKeys.settings(),
    queryFn: getPOSSyncSettings,
  });

  // Update settings mutation
  const updateSettingsMutation = useMutation({
    mutationFn: updatePOSSyncSettings,
    onSuccess: ({ success, message }) => {
      if (success) {
        successMessage(message || "Settings updated successfully");
      } else {
        errorMessage(message || "Failed to update settings");
      }
      // Invalidate to refetch in background
      queryClient.invalidateQueries({
        queryKey: posSyncSettingsKeys.settings(),
      });
      // Invalidate boot query
      queryClient.invalidateQueries({
        queryKey: ["boot"],
      });
    },
    onError: (error) => {
      errorMessage(
        error.response?.data?.message || "Failed to update settings",
      );
      // Invalidate to refetch current state from server
      queryClient.invalidateQueries({
        queryKey: posSyncSettingsKeys.settings(),
      });
    },
  });

  return {
    settingsQuery,
    updateSettingsMutation,
  };
};
